import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectsDetailPage } from './selects-detail.page';

const routes: Routes = [
  {
    path: '',
    component: SelectsDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectsDetailPageRoutingModule {}
